module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/wf-55c63880d979782164502e87292e35b5.svg";